import { useState } from "react"
import { restConfig } from "../authConfig";
import { PayoutCreditFacilityListItemModel } from '../redux/types';
import { createUrlWithQueryString } from "../utils/url";
import useFetchClient from "./useFetchClient";

const usePayoutCreditFacilitySelectorActions = () => {
  const fetchClient = useFetchClient()
  const [facilities, setFacilities] = useState<PayoutCreditFacilityListItemModel[]>()
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<Error>()

  const search = async (searchTerm: string, maxCount: number) => {
    const params = {
      query: searchTerm,
      pageNumber: 1,
      pageSize: maxCount
    }
    const url = createUrlWithQueryString(restConfig.routes.payoutCreditFacilities, params)
    
    setLoading(true)

    return fetchClient.get(url)
      .then(response => {
        setFacilities(response.data as PayoutCreditFacilityListItemModel[])
        setLoading(false)
      })
      .catch(error => {
        console.log('search error:', error)
        setError(new Error(error))
        setLoading(false)
      })
  }

  return {
    search,
    facilities,
    error,
    loading
  }
}

export default usePayoutCreditFacilitySelectorActions
